import React, { createContext, useReducer, useContext } from "react";

import { DjurServiceReducer, State, Action, INITIAL_STATE } from './reducer'

type Dispatch = (action: Action) => void

const DjurServiceContext = createContext<{
  state: State, dispatch: Dispatch
} | undefined
>(undefined)

interface IDjurServiceProvider {
  children: React.ReactNode
}

const DjurServiceProvider = ({ children }: IDjurServiceProvider) => {
  const [state, dispatch] = useReducer(DjurServiceReducer, INITIAL_STATE)

  const value = { state, dispatch }

  return (
    <DjurServiceContext.Provider
      value={value}
    >
      {children}
    </DjurServiceContext.Provider>
  )
}

const useDjurService = () => {
  const context = useContext(DjurServiceContext)

  if (context === undefined) {
    throw new Error('useDjurService must be used within a DjurServiceProvider')
  }

  return context
}

export {
  DjurServiceProvider,
  useDjurService,
}
